export default __webpack_public_path__ + "static/media/logo-poxalulu.ab3905d8.svg";